<template>
  <div class="pane" v-show="show">
    <slot></slot>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    name: 'pane',
    props:{
      name: {
        type: String
      },
      label: {
        type: String,
        default: ''
      }
    },
    data(){
      return {
        show: true
      }
    },
    methods: {
      updateNav(){
        this.$parent.updateNav();
      }
    },
    watch: {
      label(){
        this.updateNav();
      }
    },
    mounted(){
      this.updateNav()
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/base-pane.vue